'use client';

import {Toaster as Sonner} from 'sonner';

export {toast} from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme='light'
      className='toaster group'
      toastOptions={{
        classNames: {
          error: 'bg-red-50 border-iq-red text-iq-red [&_[data-icon]]:text-iq-red',
          title: 'text-sm font-semibold',
          description: 'text-sm',
        },
      }}
      {...props}
    />
  );
}
